import { ComponentConfig, FieldLabel } from '@measured/puck';
import CustomTooltip from '../../../components/common/tooltip';
import {
  getBorderProps,
  getcurrentDeviceType,
  getNewMarginStyles,
  getPaddingStyles,
} from '../../utils/helper';
import { Switch } from '@mui/material';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../puck/reusable-props/Border';
import { paddingFields, PaddingProps } from '../../puck/reusable-props/padding';
import { ReduxSelectorProps } from '../../services/constants';
import { Startrateing } from './StarRating';
import { JustifyOptions, StartrateOptions } from '../../utils/constants';
import showComponent, {
  showComponentProps,
} from '../../puck/reusable-props/showComponent';
import { QuillTextEditor } from '../../puck/reusable-props/quill-editor';
import WidthAndHeight, {
  WidthAndHeightSubProps,
} from '../../puck/reusable-props/widthAndHeight';
import { backgroungFields } from '../../puck/reusable-props/backgroungFields';
import WithAccordion from '../customComponents/CustomAccordion';
import { Select } from '../form-fields/Select';
import { marginFields, MarginProps } from '../../puck/reusable-props/NewMargin';

export type StarProps = {
  border: IBorderValueProps;
  content: string;
  Startrate: string;
  starCustamize: {
    StarSizeControl: WidthAndHeightSubProps;
    hideStar: boolean;
    justifyContent: string;
  };
  background: {
    color: string;
    isInherit: boolean;
  };
} & MarginProps &
  PaddingProps &
  showComponentProps;

export const Startrate = ({
  useAppSelector,
}: ReduxSelectorProps): ComponentConfig<StarProps> => {
  return {
    label: (
      <CustomTooltip title="Star Rating">
        <span>Star Rating</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,
      ...marginFields,
      ...paddingFields,
      border: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <Border value={value} onChange={onChange} title="Border" />
        ),
      },
      content: {
        ...QuillTextEditor('Content').content,
      },
      starCustamize: {
        type: 'custom',
        label: 'Star Customize',
        render: ({ value, onChange }) => {
          return (
            <>
              <WithAccordion title="Star Customize">
                <WidthAndHeight
                  value={value?.StarSizeControl}
                  onChange={val => {
                    onChange({
                      ...value,
                      StarSizeControl: val,
                    });
                  }}
                  title={'Star Size Control'}
                />
                <FieldLabel
                  label={
                    (
                      <CustomTooltip title="Hide Star Rating">
                        <span>Hide Star Rating</span>
                      </CustomTooltip>
                    ) as React.ReactNode as string
                  }>
                  <Switch
                    className="flex justify-between items-center mb-3"
                    checked={value?.hideStar}
                    onChange={e => {
                      const selectedValue = e.target.checked;
                      onChange({
                        ...value,
                        hideStar: selectedValue,
                      });
                    }}
                  />
                </FieldLabel>
                <FieldLabel
                  label={
                    (
                      <CustomTooltip title="Justify Content">
                        <span>Justify Content</span>
                      </CustomTooltip>
                    ) as React.ReactNode as string
                  }>
                  <Select
                    className="pagebuilder-theme"
                    value={value?.justifyContent}
                    onChange={e => {
                      const selectedValue = e.target.value;
                      onChange({
                        ...value,
                        justifyContent: selectedValue,
                      });
                    }}
                    options={JustifyOptions}
                  />
                </FieldLabel>
              </WithAccordion>
            </>
          );
        },
      },

      Startrate: {
        type: 'select',
        label: 'Start rate',
        options: StartrateOptions,
      },

      ...backgroungFields,
    },

    defaultProps: {
      background: {
        color: '#FFFFFF',
        isInherit: false,
      },
      content:
        '<p style="line-height:1.5;"><span style="font-size: 16px;">Best Seller</span></p>',
      starCustamize: {
        StarSizeControl: {
          height: {
            desktop: '20',
            mobile: '20',
            tablet: '20',
          },
          maxWidth: {
            desktop: '20',
            mobile: '20',
            tablet: '20',
          },
          deviceType: 'desktop',
        },
        hideStar: false,
        justifyContent: 'justify-center',
      },
      showComponent: ['desktop', 'tablet', 'mobile'],
      ...borderProps,
      margin: {
        deviceType: 'desktop',
        marginBottom: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        marginLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        marginRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        marginTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
      },
      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
      },
      Startrate: '0', // Default star rating
    },
    render: ({
      margin,
      padding,
      border,
      starCustamize,
      editMode,
      Startrate,
      background,
      content,
      showComponent,
    }) => {
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const marginStyles = getNewMarginStyles(margin, currentDeviceType);
      const paddingStyles = getPaddingStyles(padding, currentDeviceType);
      const borderStyles = getBorderProps(border, currentDeviceType);

      return (
        <>
          {showComponent?.includes(currentDeviceType) && (
            <div
              style={{
                ...marginStyles,
                ...paddingStyles,
                ...borderStyles,
              }}
              className={`flex w-full h-full ${starCustamize.justifyContent} ${border?.borderStyle?.[currentDeviceType]}`}>
              <Startrateing
                background={background}
                ratingValue={parseFloat(Startrate || '0')}
                maxWidth={starCustamize?.StarSizeControl.maxWidth}
                height={starCustamize?.StarSizeControl.height}
                currentDeviceType={currentDeviceType}
                content={content}
                hideRating={starCustamize?.hideStar}
              />
            </div>
          )}
        </>
      );
    },
  };
};
